const isDisabled = (value?: boolean | null) => value === true

export const AvailabilityParts = {
  isDisabled,
}
